import { useState, useEffect } from "react";
import { Button, TextInput, PasswordInput, Select, Group, Stack, ActionIcon, Text } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";

const generatePassword = (length = 12) => {
  const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=";
  let password = "";
  for (let i = 0, n = charset.length; i < length; ++i) {
    password += charset.charAt(Math.floor(Math.random() * n));
  }
  return password;
};

export function UserForm({ user, onSubmit, onCancel, isSaving, error, currentUserId }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "USER",
  });

  const isEditingSelf = user && user.id === currentUserId;

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || "",
        email: user.email || "",
        password: "",
        role: user.role || "USER",
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        name: "",
        email: "",
        role: "USER",
        password: generatePassword(),
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleGeneratePassword = () => {
    setFormData((prev) => ({ ...prev, password: generatePassword() }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack gap="md">
        <TextInput
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <TextInput
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        
        <Group align="flex-end" gap="xs">
             <PasswordInput
                label="Password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder={user ? "Leave blank to keep current" : ""}
                required={!user}
                style={{ flex: 1 }}
             />
             <ActionIcon variant="default" size="lg" onClick={handleGeneratePassword} mb={2}>
                <IconRefresh size={16} />
             </ActionIcon>
        </Group>

        <Select
            label="Role"
            name="role"
            value={formData.role}
            onChange={(value) => setFormData(prev => ({ ...prev, role: value }))}
            data={[
                { value: 'USER', label: 'User' },
                { value: 'ADMIN', label: 'Admin' },
            ]}
            disabled={isEditingSelf}
            required
            description={isEditingSelf ? "You cannot change your own role" : null}
        />

        {error && <Text c="red" size="sm" ta="center">{error}</Text>}

        <Group justify="flex-end" mt="md">
            <Button variant="default" onClick={onCancel}>Cancel</Button>
            <Button type="submit" loading={isSaving}>
                {user ? "Save Changes" : "Create User"}
            </Button>
        </Group>
      </Stack>
    </form>
  );
}
